var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"np-section-loader np-py-2"},[_c('div',{staticClass:"np-flex np-h-4 np-items-center np-justify-center",style:({ height: (_vm.scale + "rem") })},[_c('span',{staticClass:"np-section-loader__loader",style:({
				borderWidth: ("calc(2px * " + _vm.scale + ")"),
				height: (_vm.scale + "rem"),
				width: (_vm.scale + "rem"),
			})})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }